module.exports = __webpack_public_path__ + "img/zhuansu-1.png";